import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

export function LegalNotes() {
  const { t, i18n } = useTranslation('legal')

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('legalNotes.meta.title')}</title>
        <meta name="description" content={t('legalNotes.meta.description')} />
      </Helmet>

      <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gray-900">
        <div className="container-custom">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white"
          >
            {t('legalNotes.title')}
          </motion.h1>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-sm sm:prose-lg">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {t('legalNotes.company.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('legalNotes.company.name')}<br />
                {t('legalNotes.company.address')}<br />
                {t('legalNotes.company.vat')}<br />
                {t('legalNotes.company.email')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('legalNotes.terms.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                {t('legalNotes.terms.p1')}
              </p>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('legalNotes.terms.p2')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('legalNotes.intellectual.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('legalNotes.intellectual.text')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('legalNotes.liability.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                {t('legalNotes.liability.text')}
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 mt-6 sm:mt-8">
                {t('legalNotes.law.title')}
              </h2>
              <p className="text-sm sm:text-base text-gray-700">
                {t('legalNotes.law.text')}
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}
